export const mappinoAttributionHtml =
  '<a href="/" rel="home">مپینو | mappino.ir</a> · © <a href="https://www.openstreetmap.org/copyright" rel="license noopener noreferrer" target="_blank">OpenStreetMap</a>';

export function countOpenStreetMapAttributions(html: string): number {
  return (html.match(/OpenStreetMap/g) ?? []).length;
}
